function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useMemo } from 'react';
import { isDashboardPlugin, isLegacyDashboardPlugin } from "./PluginTypes.js";
import { usePlugins } from "./usePlugins.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function getDashboardPlugins(plugins) {
  var dbPlugins = [...plugins.entries()].filter(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
      plugin = _ref2[1];
    return isDashboardPlugin(plugin) || isLegacyDashboardPlugin(plugin);
  });
  return dbPlugins.map(_ref3 => {
    var _ref4 = _slicedToArray(_ref3, 2),
      pluginName = _ref4[0],
      plugin = _ref4[1];
    if (isLegacyDashboardPlugin(plugin)) {
      var _DPlugin = plugin.DashboardPlugin;
      return /*#__PURE__*/_jsx(_DPlugin, {}, pluginName);
    }
    var DPlugin = plugin.component;
    return /*#__PURE__*/_jsx(DPlugin, {}, pluginName);
  });
}

/**
 * Get all DashboardPlugin elements from the plugins context
 * @returns Array of DashboardPlugin elements
 */
export function useDashboardPlugins() {
  var plugins = usePlugins();
  var dashboardPlugins = useMemo(() => getDashboardPlugins(plugins), [plugins]);
  return dashboardPlugins;
}
export default useDashboardPlugins;
//# sourceMappingURL=useDashboardPlugins.js.map